/**
 * TrendDownChartIcon — falling bars + trend arrow (weight loss).
 * Bars stay fully under the trend corridor (no stroke/bar overlap).
 */
import React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function TrendDownChartIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      {/* Bars — leave a clear corridor for the stroke + arrow */}
      <Rect x="1.8" y="12" width="2.9" height="9" rx="0.5" fill={color} />
      <Rect x="5.7" y="14.5" width="2.9" height="6.5" rx="0.5" fill={color} />
      <Rect x="9.6" y="13.2" width="2.9" height="7.8" rx="0.5" fill={color} />
      <Rect x="13.5" y="17" width="2.9" height="4" rx="0.5" fill={color} />
      {/* Trend + arrow entirely above / past the bars */}
      <Path
        d="M2.8 6.4 L7 11.2 L10.8 8.2 L15.2 13"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <Path d="M14 11.6 L20.4 17.4 L17.2 18.6 Z" fill={color} />
    </Svg>
  );
}

export default TrendDownChartIcon;
